/** @module view */ /** for typedoc */
export * from "./interface";
export * from "./view";



/** WEBPACK FOOTER **
 ** ./view/module.ts
 **/